import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IAxiosBaseQuery extends AxiosRequestConfig {
  body?: unknown;
}
export interface IAxiosBaseQueryError {
  code?: number;
  message?: string;
}

const axiosBaseQuery =
  (adapter: AxiosInstance): BaseQueryFn<IAxiosBaseQuery, unknown, IAxiosBaseQueryError> =>
  async ({ url, method, body }) => {
    try {
      // @ts-expect-error
      const result = await adapter[method](url, body);
      return { data: result.data };
    } catch (axiosError) {
      const error = axiosError as AxiosError;

      return {
        error: {
          code: error.response?.status,
          message: error.response?.data || error.message,
        },
      };
    }
  };

export default axiosBaseQuery;
